<script setup lang="ts">
import BaseModal from './BaseModal.vue';
import { useModalStore } from '@/features/modals/modalStore';

const modalStore = useModalStore();
const emit = defineEmits(['cancel', 'close']);

const confirm = () => {
  const disabledAutoClose = modalStore.modal.props.disableAutoClose;
  if (modalStore.modal.props.onConfirm) {
    modalStore.modal.props.onConfirm()
  }

  if (!disabledAutoClose) {
    emit('close');
  }
};

const cancel = () => {
  emit('cancel');
  emit('close');
};
</script>

<template>
  <BaseModal :is-open="true" @close="emit('close')">
    <p v-html="modalStore.modal.props.message ?? 'Вы уверены?'" style="margin-top: 5px; text-align: center" />
    <div class="modal-actions">
      <button @click="confirm" class="confirm-button">{{ modalStore.modal.props.confirmText ?? "Да" }}</button>
      <button @click="cancel" class="cancel-button">{{ modalStore.modal.props.cancelText ?? "Нет" }}</button>
    </div>
  </BaseModal>
</template>

<style scoped>
.modal-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
}

.confirm-button {
  padding: 8px 16px;
  background-color: var(--purple);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button {
  padding: 8px 16px;
  background-color: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
